import { CalcBuilderComment } from "src/models/calculation-builder/CalcBuilderComment";
import { PLIConfig, PLIConfigMetadata, PLIConfigStep, PLIConfigTemplateSection, PLITemplateType } from "src/models/calculation-builder/pli-config/PLIConfigTemplate";

export default interface PLIConfigState {
    pliTemplates: PLITemplateType[];
    selectedPLITemplate: PLITemplateType;
    pliConfigMetadata?: PLIConfigMetadata;
    pliConfig?: PLIConfig,
    templateSections: PLIConfigTemplateSection[],
    stepBeingEdited?: PLIConfigStep,
    sectionBeingEdited?: PLIConfigTemplateSection,
    error?: string,
    updateStepPayload?: any,
    allSectionsAreSaved: boolean,
    allSectionsAreValid: boolean,
    stepsThatNeedSaving: PLIConfigStep[],
    removeStepModalPayload?: any,
    deleteStepPayload?: any
    commentsModalPayload?: any,
    addCommentPayload?: CalcBuilderComment,
    commentsHistory: Array<CalcBuilderComment>,
    commentsNeedRefresh: boolean,
    unsavedComments: Array<CalcBuilderComment>,
}

export const initialState: PLIConfigState = {
    pliTemplates: [],
    templateSections: [],
    selectedPLITemplate: {} as PLITemplateType,
    allSectionsAreSaved: true,
    allSectionsAreValid: false,
    stepsThatNeedSaving: [],
    commentsHistory: [],
    commentsNeedRefresh: false,
    unsavedComments: []
}